import { actionCreatorFactory } from "typescript-fsa";
import { scanmaster, scriptitem} from "../typing/table_typing";


const actionCreator = actionCreatorFactory("SCRIPTABLE");

 const resetData = actionCreator<{data:scriptitem[]}>("SCRIPTABLE_RESETDATA");
 const setDeleteItem = actionCreator<{setDeleteItem:string}>("SCRIPTABLE_DELETEDATA");
 const setRuleScanmasterItem = actionCreator<{setScanMasterItem:scanmaster[]}>("SCRIPTABLE_RULESCANMSTERDATA");
 
 export const NetworkTableThingyActions = { resetData, setDeleteItem, setRuleScanmasterItem}


